import type { FocusFallbackPerLayer } from './focus-types';

export const fallbackLookUpTable: FocusFallbackPerLayer = {
  advertising: {
    audioTrack: 'playPause',
    audioTrackOption: '',
    close: 'playPause',
    fullscreen: 'playPause',
    playNextMedium: 'playPause',
    playPause: '',
    playPausePrime: 'playPause',
    playbackSpeed: 'playPause',
    playbackSpeedOption: '',
    replay: 'playPause',
    replayPrime: 'playPause',
    seekBackward: 'playPause',
    seekBackwardPrime: 'playPause',
    seekForward: 'playPause',
    seekForwardPrime: 'playPause',
    seekbarSlider: 'playPause',
    share: 'playPause',
    start: 'playPause',
    startPrime: 'playPause',
    textTrack: 'playPause',
    textTrackOption: '',
    volume: 'playPause',
    volumeSlider: 'playPause',
  },
  content: {
    audioTrack: 'playPause',
    audioTrackOption: '',
    close: 'playPause',
    fullscreen: 'playPause',
    playNextMedium: 'playPause',
    playPause: '',
    playPausePrime: 'playPause',
    playbackSpeed: 'playPause',
    playbackSpeedOption: '',
    replay: 'playPause',
    replayPrime: 'playPausePrime',
    seekBackward: 'playPause',
    seekBackwardPrime: 'playPause',
    seekForward: 'playPause',
    seekForwardPrime: 'playPause',
    seekbarSlider: 'playPause',
    share: 'playPause',
    start: 'playPause',
    startPrime: 'playPausePrime',
    textTrack: 'playPause',
    textTrackOption: '',
    volume: 'playPause',
    volumeSlider: 'playPause',
  },
  loading: {
    audioTrack: '',
    audioTrackOption: '',
    close: '',
    fullscreen: '',
    playNextMedium: '',
    playPause: '',
    playPausePrime: '',
    playbackSpeed: '',
    playbackSpeedOption: '',
    replay: '',
    replayPrime: '',
    seekBackward: '',
    seekBackwardPrime: '',
    seekForward: '',
    seekForwardPrime: '',
    seekbarSlider: '',
    start: '',
    share: '',
    startPrime: '',
    textTrack: '',
    textTrackOption: '',
    volume: '',
    volumeSlider: '',
  },
  nextMediumPreview: {
    audioTrack: 'playNextMedium',
    audioTrackOption: 'playNextMedium',
    close: 'playNextMedium',
    fullscreen: 'playNextMedium',
    playNextMedium: 'playNextMedium',
    playPause: 'playNextMedium',
    playPausePrime: 'playNextMedium',
    playbackSpeed: 'playNextMedium',
    playbackSpeedOption: 'playNextMedium',
    replay: 'playNextMedium',
    replayPrime: 'playNextMedium',
    seekBackward: 'playNextMedium',
    seekBackwardPrime: 'playNextMedium',
    seekForward: 'playNextMedium',
    seekForwardPrime: 'playNextMedium',
    seekbarSlider: 'playNextMedium',
    share: 'playNextMedium',
    start: 'playNextMedium',
    startPrime: 'playNextMedium',
    textTrack: 'playNextMedium',
    textTrackOption: 'playNextMedium',
    volume: 'playNextMedium',
    volumeSlider: 'playNextMedium',
  },
  replay: {
    audioTrack: 'replayPrime',
    audioTrackOption: 'replayPrime',
    close: 'replayPrime',
    fullscreen: 'replayPrime',
    playNextMedium: 'replayPrime',
    playPause: 'replayPrime',
    playPausePrime: 'replayPrime',
    playbackSpeed: 'replayPrime',
    playbackSpeedOption: 'replayPrime',
    replay: '',
    replayPrime: 'replayPrime',
    seekBackward: 'replayPrime',
    seekBackwardPrime: 'replayPrime',
    seekForward: 'replayPrime',
    seekForwardPrime: 'replayPrime',
    seekbarSlider: 'replayPrime',
    share: 'replayPrime',
    start: '',
    startPrime: 'replayPrime',
    textTrack: 'replayPrime',
    textTrackOption: 'replayPrime',
    volume: 'replayPrime',
    volumeSlider: 'replayPrime',
  },
  start: {
    audioTrack: 'startPrime',
    audioTrackOption: 'startPrime',
    close: 'startPrime',
    fullscreen: 'startPrime',
    playNextMedium: 'startPrime',
    playPause: 'startPrime',
    playPausePrime: 'startPrime',
    playbackSpeed: 'startPrime',
    playbackSpeedOption: 'startPrime',
    replay: 'startPrime',
    replayPrime: 'startPrime',
    seekBackward: 'startPrime',
    seekBackwardPrime: 'startPrime',
    seekForward: 'startPrime',
    seekForwardPrime: 'startPrime',
    seekbarSlider: 'startPrime',
    share: 'startPrime',
    start: 'startPrime',
    startPrime: 'startPrime',
    textTrack: 'startPrime',
    textTrackOption: 'startPrime',
    volume: 'startPrime',
    volumeSlider: 'startPrime',
  },
};
